import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './methods'
import './common/stylus/index.styl'
import './registerServiceWorker'
import 'amfe-flexible'
import './common/css/common.css'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
